export default __webpack_public_path__ + "static/media/logout.16c655c7.svg";